module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/raw-loader!./media/svg/format_italic.svg
// module id = ../node_modules/raw-loader/index.js!./media/svg/format_italic.svg
// module chunks = 1